export var INSTITUION_SHORT_NAME;
(function (INSTITUION_SHORT_NAME) {
    INSTITUION_SHORT_NAME["RBC"] = "RBC";
    INSTITUION_SHORT_NAME["TD"] = "TDBank";
    INSTITUION_SHORT_NAME["BMO"] = "BMO";
    INSTITUION_SHORT_NAME["CIBC"] = "CIBC";
    INSTITUION_SHORT_NAME["SCOTIA"] = "ScotiaBank";
    INSTITUION_SHORT_NAME["TANGERINE"] = "Tangerine";
    INSTITUION_SHORT_NAME["DESJARDINS"] = "Desjardins";
    INSTITUION_SHORT_NAME["NBC"] = "NBC";
    INSTITUION_SHORT_NAME["HSBC"] = "HSBC";
    INSTITUION_SHORT_NAME["LAURENTIAN"] = "Laurentian";
    INSTITUION_SHORT_NAME["WS"] = "Wealthsimple";
    INSTITUION_SHORT_NAME["ATB"] = "ATB";
})(INSTITUION_SHORT_NAME || (INSTITUION_SHORT_NAME = {}));
//# sourceMappingURL=FundingAccount.js.map